import { useState, useEffect } from "react";

const Record = ({ name }) => {
  const [record, setRecord] = useState({ won: 0, draw: 0, lost: 0 });

  useEffect(() => {
    if (!name) return;
    fetch(`${process.env.REACT_APP_API_URL}/api/soccer/team/${encodeURIComponent(name)}/standings`)
    //fetch(`http://localhost:5001/api/soccer/team/${encodeURIComponent(name)}/standings`)
      .then((res) => res.json())
      .then((data) => {
        setRecord({
          won: data.won ?? 0,
          draw: data.draw ?? 0,
          lost: data.lost ?? 0
        });
      })
      .catch((err) => {
        console.log("record error:", err);
        setRecord({ won: 0, draw: 0, lost: 0 });
      });
  }, [name]);

  return <span>{record.won} - {record.draw} - {record.lost}</span>;
};

export default Record;